<template>
    <QPaginatedSearchDropdown :value="value" :list-getter="getContractListFromFilter" :filter="filter"
        :min-search-char-limit="0" :externaledit="externaledit" :clearable="clearable" :multiple="multiple"
        :returnobject="returnobject" :disabled="disabled" :loading="loading" valuekey="Id" textkey="Name"
        :label="label ? label : $t('servicesystem.common_objects.contract.contract')"
        :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.contract.search_field_label')"
        @input="e => $emit('input', e)" @FocusState="e => $emit('FocusState', e)">
        <template v-if="!hideIcon" v-slot:prepend-outer>
            <v-icon size="20">mdi-file-document</v-icon>
        </template>
    </QPaginatedSearchDropdown>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
    name: "ContractSelect2",
    model: {
        prop: "value",
        event: "input",
    },
    props: {
        label: String,
        placeholder: String,
        value: [Object, String, Number, Array],
        clearable: Boolean,
        disabled: Boolean,
        loading: Boolean,
        externaledit: Boolean,
        filter: Object,
        returnobject: Boolean,
        multiple: Boolean,
        hideIcon: Boolean,
    },
    components: {
        QPaginatedSearchDropdown,
    },
    mixins: [clientAPI, rules],

    data() {
        return {
        };
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>

<style lang="scss"></style>
